import React from 'react'

const ArrowRightBoldCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnslink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24">
    <path d="M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M17,12L12,7V10H8V14H12V17L17,12Z" />
  </svg>
)

export default ArrowRightBoldCircle



// WEBPACK FOOTER //
// ./src/components/icons/ArrowRightBoldCircle.jsx